import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'components/atoms/checkbox';
import { SettingsControlPanel } from 'components/molecules/settings/control-panel';
import { useTranslation } from 'hooks/use-translation';
import { useUpdateSettings } from '../use-feature-setting';
import { CheckBoxWrap } from './components';

interface Props {
  reasonDescriptionMandatory?: boolean;
}

export const ReasonDescriptionSettings: FC<Props> = ({
  reasonDescriptionMandatory: defaultReasonDescriptionMandatory,
}) => {
  const [reasonDescriptionMandatory, setReasonDescriptionMandatory] = useState(
    defaultReasonDescriptionMandatory,
  );
  const [update] = useUpdateSettings();
  const label = useTranslation('settings.credit_notes.reason_description');

  return (
    <SettingsControlPanel label={label}>
      <CheckBoxWrap>
        <Checkbox
          checked={reasonDescriptionMandatory}
          onChange={(e) => {
            setReasonDescriptionMandatory(e.target.checked);
            update({
              payload: {
                reasonDescriptionMandatory: e.target.checked,
              },
              onError: () => {
                setReasonDescriptionMandatory(!e.target.checked);
              },
            });
          }}
        >
          <FormattedMessage id="settings.credit_notes.reason_description.checkbox" />
        </Checkbox>
      </CheckBoxWrap>
    </SettingsControlPanel>
  );
};
